module.exports = {
  messages: {
    COMPANY_DIRECTORY_LIST_H: 'Unternehmen nach Anfangsbuchstaben',
    COMPANY_DIRECTORY_OTHERS: 'Weitere',
    DISCIPLINE_1001: 'Analyse und Statistik',
    DISCIPLINE_1002: 'Administration, Sachbearbeitung und Verwaltung',
    DISCIPLINE_1003: 'Beratung / Consulting',
    DISCIPLINE_1004: 'Kundenbetreuung',
    DISCIPLINE_1005: 'Einkauf, Materialwirtschaft und Logistik',
    DISCIPLINE_1006: 'Finanzen, Rechnungswesen und Controlling',
    DISCIPLINE_1007: 'Forschung, Lehre und Entwicklung',
    DISCIPLINE_1008: 'Gesundheit, Medizin und Soziales',
    DISCIPLINE_1009: 'Grafik, Design und Architektur',
    DISCIPLINE_1010: 'Ingenieurwesen und technische Berufe',
    DISCIPLINE_1011: 'IT und Softwareentwicklung',
    DISCIPLINE_1012: 'Management und Unternehmensentwicklung',
    DISCIPLINE_1013: 'Marketing und Werbung',
    DISCIPLINE_1014: 'Personalwesen und HR',
    DISCIPLINE_1015: 'PR, Öffentlichkeitsarbeit und Journalismus',
    DISCIPLINE_1016: 'Produktion und Handwerk',
    DISCIPLINE_1017: 'Produktmanagement',
    DISCIPLINE_1018: 'Projektmanagement',
    DISCIPLINE_1019: 'Prozessplanung und Qualitätssicherung',
    DISCIPLINE_1020: 'Recht',
    DISCIPLINE_1021: 'Vertrieb und Handel',
    DISCIPLINE_1022: 'Sonstige Tätigkeitsfelder',
    EMPLOYMENT_TYPE_CONTRACTOR: 'Selbstständig',
    EMPLOYMENT_TYPE_CONTRACTOR_LOCAL_SERPS: 'Freelancer',
    EMPLOYMENT_TYPE_FULL_TIME: 'Vollzeit',
    EMPLOYMENT_TYPE_INTERN: 'Studierende',
    EMPLOYMENT_TYPE_PART_TIME: 'Teilzeit',
    EMPLOYMENT_TYPE_SEASONAL: 'Saisonarbeit',
    EMPLOYMENT_TYPE_STUDENT_LOCAL_SERPS: 'Studentenjobs',
    EMPLOYMENT_TYPE_TEMPORARY: 'Aushilfe',
    EMPLOYMENT_TYPE_TEMPORARY_LOCAL_SERPS: 'Mini',
    EMPLOYMENT_TYPE_VOLUNTARY: 'Ehrenamt',
    JOB_SEO_CATEGORY_JOBS: '{category} Jobs',
    JOB_SEO_CITY_JOBS: 'Jobs in {city}',
    JOB_SEO_COMPANY_JOBS: '{term} Jobs',
    JOB_SEO_EMPLOYMENT_TYPE_: 'Ehrenamt-Jobs',
    JOB_SEO_EMPLOYMENT_TYPE_CONTRACTOR: 'Freelancer-Jobs',
    JOB_SEO_EMPLOYMENT_TYPE_FULL_TIME: 'Vollzeit-Jobs',
    JOB_SEO_EMPLOYMENT_TYPE_INTERN: 'Studierende-Jobs',
    JOB_SEO_EMPLOYMENT_TYPE_PART_TIME: 'Teilzeit-Jobs',
    JOB_SEO_EMPLOYMENT_TYPE_SEASONAL: 'Saisonarbeit-Jobs',
    JOB_SEO_EMPLOYMENT_TYPE_TEMPORARY: 'Aushilfe-Jobs',
    JOB_SEO_JOB_TYPE_CONTRACTOR_JOBS:
      'Finde jetzt Aufträge und Projekte für Freiberufler.',
    JOB_SEO_JOB_TYPE_FULL_TIME_JOBS: 'Finde jetzt Deine neue Vollzeitstelle.',
    JOB_SEO_JOB_TYPE_INTERN_JOBS: 'Finde jetzt das ideale Praktikum.',
    JOB_SEO_JOB_TYPE_PART_TIME_JOBS: 'Finde jetzt Deine neue Teilzeitstelle.',
    JOB_SEO_JOB_TYPE_SEASONAL_JOBS: 'Finde jetzt Deine nächste Saisonarbeit.',
    JOB_SEO_JOB_TYPE_TEMPORARY_JOBS:
      'Finde jetzt Deine nächste Aushilfestelle.',
    JOB_SEO_JOB_TYPE_VOLUNTARY_JOBS: 'Finde jetzt ein Ehrenamt.',
    JOB_SEO_SERPS_EMPTY_SEARCH: 'Keine Ergebnisse für {keyword}',
    JOB_SEO_TERM_JOBS: '{term} Jobs',
    JOBS_SEARCH_EMPTY_STATE_NO_RESULTS_FOR_LABEL: 'für',
    JOBS_SEARCH_EMPTY_STATE_NO_RESULTS_TITLE: 'Keine Ergebnisse',
    MP_000_RESOURCE_JOB_TYPES_TEMPORARY: 'Minijobs',
    XJM_BREADCRUMB_HOME: 'Jobbörse',
    XJM_JOBS_SEO_ROLE_FAQ_HEADLINE: 'Häufig gestellte Fragen',
    XJM_JOBS_SEO_ROLE_FAQ_TOP_CITY_ANSWER:
      'Die beliebteste Stadt für {jobRole} ist {firstCity}.',
    XJM_JOBS_SEO_ROLE_FAQ_TOP_CITY_QUESTION:
      'Wo gibt es am meisten offene Stellen für {jobRole}?',
    XJM_JOBS_SEO_ROLE_FAQ_TOP_SKILL_ANSWER:
      'Für einen Job als {jobRole} ist vor allem {firstSkill} von Vorteil.',
    XJM_JOBS_SEO_ROLE_FAQ_TOP_SKILL_QUESTION:
      'Welche Fähigkeiten braucht man als {jobRole}?',
    XJM_JOBS_SEO_ROLE_FAQ_TOP_THREE_CITIES_ANSWER:
      'Die beliebtesten Städte für {jobRole} sind {firstCity}, {secondCity}, und {thirdCity}.',
    XJM_JOBS_SEO_ROLE_FAQ_TOP_THREE_SKILLS_ANSWER:
      'Für einen Job als {jobRole} sind vor allem {firstSkill}, {secondSkill} und {thirdSkill} von Vorteil.',
    XJM_JOBS_SEO_ROLE_FAQ_TOP_TWO_CITIES_ANSWER:
      'Die beliebtesten Städte für {jobRole} sind {firstCity} und {secondCity}.',
    XJM_JOBS_SEO_ROLE_FAQ_TOP_TWO_SKILLS_ANSWER:
      'Für einen Job als {jobRole} sind vor allem {firstSkill} und {secondSkill} von Vorteil. ',
    XJM_JOBS_SEO_ROLE_RELATED_JOBS_HEADLINE: 'Verwandte Jobs',
    XJM_JOBS_SEO_ROLE_SALARY_DESCRIPTION:
      'Der Großteil der als {jobRole} Beschäftigten verdienen in Deutschland zwischen {minimumSalary} und {maximumSalary} wobei der Durchschnitt bei {averageSalary}€ liegt. ',
    XJM_JOBS_SEO_ROLE_SALARY_HEADER: 'Was verdient man als {jobRole}?',
    XJM_JOBS_SEO_ROLE_SALARY_LABEL: 'Durchschnittsgehalt pro Jahr',
    XJM_META_DESCRIPTION_CATEGORY:
      '✔ Offene {category}-Stellen  ✔ Top-Arbeitgebern aus der Branche {category} ✔ Neues aus dem modernen Arbeitsleben',
    XJM_META_DESCRIPTION_CATEGORY_CITY:
      '✔ {city}er Jobs im Bereich {category} ✔ Die populärsten {city}er Arbeitgeber ✔ Die neuesten Trend der modernen Arbeitswelt',
    XJM_META_DESCRIPTION_CATEGORY_TERM:
      '✔ Aktuelle {term}-Jobs im Bereich {category}  ✔ Persönliche Job-Vorschläge für Dich ✔ Die beliebtesten Arbeitgeber in Deiner Nähe',
    XJM_META_DESCRIPTION_CITY_WITH_POSTINGS:
      '{postings} Jobs in {city} im XING Jobs-Netzwerk. Finde den Job, der zu Dir passt.',
    XJM_META_DESCRIPTION_COMPANY:
      '{term} Jobs im XING Jobs-Netzwerk ✓ Gehaltsspannen zu den Jobs erfahren ✓ Jetzt auf XING Deinen Traumjob finden!',
    XJM_META_DESCRIPTION_EMPLOYMENT_TYPE_CITY_WITH_POSTINGS:
      '{postings} {employmentType} Jobs in {city} im XING Jobs-Netzwerk. Finde den Job, der zu Dir passt.',
    XJM_META_DESCRIPTION_JOB_TYPE:
      '✔ Aktuelle Jobs ({job_type}) ✔ Andere  aktuelle Stellenangebote ✔ Die besten Arbeitgeber ✔ Interessante Infos rund um die moderne Arbeitswelt',
    XJM_META_DESCRIPTION_JOB_TYPE_CATEGORY:
      '✔ Aktuelle {category}-Jobs ({job_type}) ✔ Top-Arbeitgeber ✔ Wissenswertes zum Thema "Neue Arbeitswelt" ',
    XJM_META_DESCRIPTION_JOB_TYPE_TERM:
      '✔ {term}-Stellenangebote ({job_type}) ✔ Die beliebtesten Arbeitgeber ✔ Wissenswertes zur Arbeitswelt von heute',
    XJM_META_DESCRIPTION_JOB_TYPE_TERM_MINIJOBS:
      '✔ {term}-Stellenangebote (Mini-Jobs) ✔ Die beliebtesten Arbeitgeber ✔ Wissenswertes zur Arbeitswelt von heute',
    XJM_META_DESCRIPTION_SKILL:
      '{postings} {term} Jobs im XING Jobs-Netzwerk. Finde den Job, der zu Dir passt.',
    XJM_META_DESCRIPTION_SKILL_TYPE_CITY:
      '{postings} {term} Jobs in {city} im XING Jobs-Netzwerk.',
    XJM_META_DESCRIPTION_TERM_ANY_WITH_POSTINGS:
      '{postings} {term} Jobs im XING Jobs-Netzwerk. Finde den Job, der zu Dir passt.',
    XJM_META_DESCRIPTION_TERM_CITY_WITH_POSTINGS:
      '{postings} {role} Jobs in {city} im XING Jobs-Netzwerk. Finde den Job, der zu Dir passt.',
    XJM_META_DESCRIPTION_TERM_WITH_POSTINGS:
      '{postings} {role} Jobs im XING Jobs-Netzwerk. Finde den Job, der zu Dir passt.',
    XJM_META_TITLE_CATEGORY: '{category}-Jobs | XING: Jobs, die passen.',
    XJM_META_TITLE_CATEGORY_CITY:
      '{category}-Jobs in {city} | XING: Jobs, die passen.',
    XJM_META_TITLE_CATEGORY_TERM:
      '{term}-Jobs im Bereich {category} | XING: Jobs, die passen.',
    XJM_META_TITLE_CITY_WITH_DATE:
      'Aktuelle Jobs & Stellen in {city} - {month} {year}',
    XJM_META_TITLE_COMPANY: '{term} Jobs | XING Jobs-Netzwerk',
    XJM_META_TITLE_EMPLOYMENT_TYPE_CITY_WITH_DATE:
      '{employmentType} Jobs in {city} - {month} {year}',
    XJM_META_TITLE_JOB_TYPE:
      'Aktuelle Jobs ({job_type}) | XING: Jobs, die passen.',
    XJM_META_TITLE_JOB_TYPE_CATEGORY:
      '{category}-Jobs ({job_type}) | XING: Jobs, die passen.',
    XJM_META_TITLE_JOB_TYPE_TERM:
      '{term}-Jobs ({job_type}) | XING: Jobs, die passen.',
    XJM_META_TITLE_JOB_TYPE_TERM_MINIJOBS:
      '{term} Mini-Jobs | XING: Jobs, die passen.',
    XJM_META_TITLE_SKILL: 'Aktuelle {term} Jobs - {date}',
    XJM_META_TITLE_SKILL_TYPE_CITY:
      'Aktuelle {term} Jobs in {city} - {month} {year}',
    XJM_META_TITLE_TERM_ANY_WITH_DATE: 'Aktuelle {term} Jobs - {month} {year}',
    XJM_META_TITLE_TERM_CITY_WITH_POSTINGS:
      '{role} Jobs in {city} - {month} {year}',
    XJM_META_TITLE_TERM_WITH_DATE: '{role} Jobs & Stellen - {month} {year}',
    XJM_SEARCH_TITLE_CATEGORY_CITY: '{category}-Jobs in {city}',
    XJM_SEARCH_TITLE_CATEGORY_TERM: 'Finde {term}-Jobs im Bereich {category}',
    XJM_SEARCH_TITLE_EMPLOYMENT_TYPE_CITY: '{employmentType} Jobs in {city}',
    XJM_SEARCH_TITLE_EMPLOYMENT_TYPE_CITY_FREELANCER:
      'Freelancer Jobs in {city}',
    XJM_SEARCH_TITLE_EMPLOYMENT_TYPE_CITY_STUDENTEN: 'Studentenjobs in {city}',
    XJM_SEARCH_TITLE_JOB_TYPE_CATEGORY: '{category}-Jobs ({job_type})',
    XJM_SEARCH_TITLE_JOB_TYPE_CATEGORY_MINIJOBS: '{category} Minijobs',
    XJM_SEARCH_TITLE_JOB_TYPE_TERM: '{term}-Jobs ({job_type})',
    XJM_SEARCH_TITLE_SKILL_TYPE_CITY: '{term} Jobs in {city}',
    XJM_SEARCH_TITLE_TERM_CITY_WITH_DATE: '{role} Jobs in {city}',
    XJM_SEO_DIRECTORY_PAGINATION_H: 'Jobs nach Anfangsbuchstaben',
    XJM_SEO_JOB_ROLE: '{term} Jobs',
    XJM_SEO_LINK_BOXES_LOCAL_JOB_ROLE_RELATED_JOB_ROLES:
      'Verwandte Jobs in {subcategoryValue}',
    XJM_SEO_LINK_BOXES_LOCAL_SKILL: 'Beliebte Job-Suchen in {subcategoryValue}',
    XJM_SEO_LINK_BOXES_LOCAL_SKILL_RELATED_JOB_ROLES:
      'Weitere {categoryValue} Jobs in {subcategoryValue}',
    XJM_SEO_LINK_BOXES_NEARBY_JOB_ROLE:
      '{categoryValue} Jobs in der Nähe von {subcategoryValue}',
    XJM_SEO_RADIUS: 'im Umkreis von {radius} km',
    XJM_SEO_RELATED_JOB_TITLES_BY_SKILL: 'Weitere {skill} Jobs',
    XJM_SEO_RELATED_SKILLS_BY_JOB_ROLE: 'Beliebte Job-Suchen',
    XJM_SEO_TOP_CITIES_NEARBY_TITLE: 'Städte in der Nähe',
    XJM_SEO_TOP_CITIES_TITLE: 'Top-Städte',
    XJM_SEO_TOP_JOB_ROLE_LOCATIONS: 'Standorte für {role} Jobs',
    XJM_SEO_TOP_JOBS_TITLE: 'Top-Positionen',
    XJM_SEO_TOP_JOBS_TYPES_TITLE: 'Beschäftigungsarten',
    XJM_SEO_TOP_LOCATIONS_BY_SKILL: 'Top Orte für {skill} Jobs',
    XJM_SEO_XING_SERVICES_TITLE: 'XING Services',
    XJM_TEASER_LINKS_JOB_TYPE_TITLE: 'Jobs nach Beschäftigungsarten',
    XJM_TEASER_LINKS_JOBS: '-Jobs',
    XJM_TEASER_LINKS_JOBS_IN: '<strong>-Jobs</strong> in',
    XJM_TEASER_LINKS_TERM_TITLE: 'Meistgesuchte Job-Titel',
  },
};
